<template>
  <main :class="`modal modal-${size || 'sm'} ` + 'active'" v-if="active" id="modal-id">
    <a class="modal-overlay" aria-label="Close"></a>
    <div class="modal-container">
      <div class="modal-header">
        <div class="modal-title h5">{{title}}</div>
      </div>
      <div class="modal-body">
        <div class="content" v-html="body">
        </div>
      </div>
      <footer class="modal-footer">
        <span v-html="footer"></span>
        <div class="d-flex flex-space_between">
          <button
            v-if="cancelText"
            :disabled="sending"
            :class="sending ? 'disabled' : ''"
            class="btn btn-green"
            @click="beforeClosing(false)"
          >
            {{ cancelText }}
          </button>

          <button
            :disabled="sending"
            :style="!cancelText && 'margin: 0 auto'"
            :class="sending ? 'disabled' : ''"
            class="btn btn-primary"
            @click="sending = true; beforeClosing(true)"
          >
            {{ confirmText }}
          </button>
        </div>
      </footer>
    </div>
  </main>
</template>

<script>
export default {
  props: [
    'title',
    'body',
    'footer',
    'active',
    'size',
    'confirmText',
    'beforeClose',
    'callback',
    'cancelText'
  ],
  data () {
    return {
      sending: false
    }
  },
  mounted () {
    this.sending = false
  },
  watch: {
    active (next, prev) {
      if (next) {
        if (this.sending) {
          this.sending = false
        }
      }
    }
  },
  methods: {
    beforeClosing (v) {
      if (this.beforeClose) {
        this.beforeClose(v, this)
        return
      }
      this.$store.dispatch('setModalConfirm')
    },
    close () {
      if (this.callback) {
        this.callback()
      }
      this.$store.dispatch('setModalConfirm')
    }
  }
}
</script>
